"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stockRackSuggestionQuerySchema = exports.importStockRackAssignmentsSchema = exports.assignStockRackSchema = exports.updateStockRackSchema = exports.createStockRackSchema = exports.stockRackShape = exports.stockRackTypeSchema = void 0;
const zod_1 = require("zod");
const stock_rack_code_1 = require("../domain/stock-rack-code");
/** A rack code as typed: normalised first, THEN checked, so "a1 " and "A1" are the same value to every caller. */
const rackCodeSchema = zod_1.z
    .string()
    .min(1, 'Rack code is required')
    .max(stock_rack_code_1.RACK_CODE_MAX_LENGTH + 20)
    .transform(stock_rack_code_1.normalizeRackCode)
    .refine(stock_rack_code_1.isValidRackCode, {
    message: `Rack code must be 1-${stock_rack_code_1.RACK_CODE_MAX_LENGTH} characters: letters, digits, space, - _ / . (starting with a letter or digit)`,
});
exports.stockRackTypeSchema = zod_1.z.enum(stock_rack_code_1.STOCK_RACK_TYPES);
exports.stockRackShape = {
    locationId: zod_1.z.string().uuid(),
    rackCode: rackCodeSchema,
    name: zod_1.z.string().trim().max(120).optional(),
    rackType: exports.stockRackTypeSchema.default('SHELF'),
    isActive: zod_1.z.boolean().default(true),
};
exports.createStockRackSchema = zod_1.z.object(exports.stockRackShape);
/** The store of an existing rack is NOT editable: stock on it would silently change store. Make a new rack in the other store instead. */
exports.updateStockRackSchema = zod_1.z.object({
    rackCode: exports.stockRackShape.rackCode.optional(),
    name: exports.stockRackShape.name,
    rackType: exports.stockRackTypeSchema.optional(),
    isActive: zod_1.z.boolean().optional(),
});
/** Assign / re-rack: put these batches on one rack (null = take them off any rack, i.e. unracked). */
exports.assignStockRackSchema = zod_1.z.object({
    batchIds: zod_1.z.array(zod_1.z.string().uuid()).min(1).max(500),
    rackId: zod_1.z.string().uuid().nullable(),
    reason: zod_1.z.string().trim().max(200).optional(),
});
/** First-time assignment from a sheet: one row = a batch (its internal code, e.g. BAT2026000166) + the rack code it sits on. */
exports.importStockRackAssignmentsSchema = zod_1.z.object({
    locationId: zod_1.z.string().uuid(),
    /** true = check every row and change nothing (the default); false = apply the rows that passed. */
    dryRun: zod_1.z.boolean().default(true),
    rows: zod_1.z
        .array(zod_1.z.object({
        batchCode: zod_1.z.string().trim().min(1).max(50),
        rackCode: zod_1.z.string().trim().min(1).max(stock_rack_code_1.RACK_CODE_MAX_LENGTH + 20),
    }))
        .min(1)
        .max(2000),
});
/** Receive / GRN suggestion: which rack did each of these drugs last sit on in this store? */
exports.stockRackSuggestionQuerySchema = zod_1.z.object({
    locationId: zod_1.z.string().uuid(),
    drugIds: zod_1.z
        .string()
        .min(1)
        .transform((value) => value.split(',').map((id) => id.trim()).filter(Boolean))
        .pipe(zod_1.z.array(zod_1.z.string().uuid()).min(1).max(200)),
});
//# sourceMappingURL=stock-rack.schema.js.map